<template>
  <div>
    <view-title>
      <v-icon class="primary--text mr-4">fas fa-search</v-icon>
      Acervo {{ item.tipoPublicacao && item.tipoPublicacao.tipoPublicacao }}
      <template slot="button" v-if="isAdmin && item.statusFluxo === 'IN'">
        <v-col class="text-right">
          <v-row align="center" justify="center">
            <v-col>
              <strong>Operador</strong>:
              {{
                item.publicador && item.publicador.name
                  ? item.publicador.name
                  : "Não havia na importação."
              }}
            </v-col>
            <v-col>
              <v-dialog v-model="dialog" width="500">
                <template v-slot:activator="{ on }">
                  <v-btn
                    outlined
                    rounded
                    large
                    :loading="loading"
                    color="red"
                    class="font-weight-bold mr-5"
                    v-on="on"
                    >Recusar</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title class="headline primary--text" primary-title>
                    Recusar acervo
                  </v-card-title>
                  <v-card-text>
                    Você tem certeza que deseja recusar esse acervo?
                    <v-textarea
                      v-model="motive"
                      placeholder="Descreva por qual motivo esse acervo está sendo recusado"
                      :rules="[v => !!v || 'Campo requerido.']"
                      @keyup.enter.native="
                        onReject(motive);
                        motive = '';
                      "
                    >
                    </v-textarea>
                  </v-card-text>
                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn
                      color="accent"
                      class="mr-5"
                      text
                      :loading="loading"
                      @click="dialog = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      color="primary"
                      rounded
                      large
                      :loading="loading"
                      @click="
                        onReject(motive);
                        motive = '';
                      "
                      >Recusar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-btn
                rounded
                large
                color="success"
                class="font-weight-bold"
                :loading="loading"
                @click="onApprove"
                >Aprovar</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </template>
    </view-title>
    <v-dialog :value="rejectedDialog" width="400" :input="onRejectedDialogInput" persistent>
      <v-card v-if="notification">
        <v-card-title class="primary white--text">
          Acervo recusado
        </v-card-title>
        <v-card-text class="py-4">
          <p>{{ notification.explicacao }}</p>
          <p>
            <strong class="primary--text">Administrador:</strong>
            {{ notification.admin && notification.admin.name }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn class="accent--text" text :to="{ name: 'Acervo listar' }">
            Cancelar
          </v-btn>
          <v-btn
            class="primary"
            rounded
            :to="{
              name: 'Acervo editar',
              params: {
                acervo,
                id: item.id
              }
            }"
          >
            Editar acervo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container>
      <v-row>
        <v-col class="px-10">
          <v-btn text color="accent" :to="{ name: 'Acervo listar' }">
            <v-icon left>fas fa-chevron-left</v-icon> Voltar
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card class="mb-5">
            <v-card-text class="py-5 px-10">
              <form-title title="Anexos" class="mx-10" />
              <v-data-iterator
                :items="documentos"
                :options="options"
                :server-items-length="totalDocumentos"
                :loading="loading"
                :hide-default-footer="!totalDocumentos"
                :footer-props="footerProps"
                @update:options="loadDocumentos({ $event })"
                class="elevation-0"
                :class="$vuetify.breakpoint.xsOnly ? '' : 'mx-10'"
              >
                <template v-slot:default="props">
                  <v-row v-if="documentos.length">
                    <v-col
                      v-for="item in props.items"
                      :key="item.id"
                      cols="12"
                      sm="3"
                      md="2"
                      lg="2"
                    >
                      <anexo-image :documento="item" title download />
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:no-data>
                  <div class="mt-3 mb-5">
                    Nenhum anexo encontrado.
                  </div>
                </template>
              </v-data-iterator>
            </v-card-text>
          </v-card>
          <div id="highlight">
            <v-card class="mb-5">
              <v-card-text class="py-5 px-10">
                <form-title title="Informação" class="mx-10" />
                <v-row v-if="item && item.nome">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">
                      {{ item.tipoPublicacao.etapas === "depoimentos" ? "Depoente" : "Título" }}:
                    </div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    {{ item.nome }}
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    item &&
                      item.suporteBase &&
                      item.suporteBase[0] &&
                      item.suporteBase[0].registro1 &&
                      item.suporteBase[0].registro2
                  "
                >
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Registro:</div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    {{
                      `${item.suporteBase[0].registro1.trim()}
                    ${item.suporteBase[0].registro2.trim()}`
                    }}
                  </v-col>
                </v-row>
                <v-row v-if="item && item.perfilDepoente">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Perfil do depoente:</div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    {{ item.perfilDepoente }}
                  </v-col>
                </v-row>
                <v-row v-if="item && item.duracao">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Duração:</div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    {{ item.duracao }}
                  </v-col>
                </v-row>
                <v-row v-if="item && item.localidade">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">
                      Local:
                    </div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    {{ item.localidade }}
                  </v-col>
                </v-row>
                <v-row v-if="item && item.tipoObjeto && item.tipoObjeto.idTipoobjetoFkrel">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">
                      {{
                        item.tipoPublicacao.etapas === "textual"
                          ? "Espécie Documental:"
                          : "Tipo de objeto:"
                      }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    {{ item.tipoObjeto.idTipoobjetoFkrel.tipoObjeto }}
                  </v-col>
                </v-row>
                <v-row v-if="item && item.entrevistador">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Entrevistador:</div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    {{ item.entrevistador }}
                  </v-col>
                </v-row>
                <v-row v-if="item && item.sinopse">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Tema:</div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    {{ item.sinopse }}
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    item &&
                      item.segmento &&
                      item.segmento.idSegmentoFkrel &&
                      item.segmento.idSegmentoFkrel.segmento
                  "
                >
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Área:</div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    {{ item.segmento.idSegmentoFkrel.segmento }}
                  </v-col>
                </v-row>
                <v-row v-if="item && item.familias && item.familias.length">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Tipo da publicação:</div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    <span v-for="fa in item.familias" :key="fa.id">
                      {{ fa.familiaFkrel.descricao }};
                    </span>
                  </v-col>
                </v-row>
                <v-row v-if="item && item.dtImagem">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Data inicial:</div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    {{ formatDateAsDayMonthAndYearUTC(item.dtImagem) }}
                  </v-col>
                </v-row>
                <v-row v-if="item && item.dtLimite">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Data final:</div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    {{ formatDateAsDayMonthAndYearUTC(item.dtLimite) }}
                  </v-col>
                </v-row>
                <v-row v-if="item && item.idioma && item.idioma.idIdiomaPubFkrel">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Idioma:</div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    {{ item.idioma.idIdiomaPubFkrel.idioma }}
                  </v-col>
                </v-row>
                <v-row v-if="item && (item.fonte || item.autor)">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Autor:</div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    {{ item.fonte || item.autor }}
                  </v-col>
                </v-row>
                <v-row v-if="item && item.conteudo">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Descrição:</div>
                  </v-col>
                  <v-col cols="12" sm="10" v-html="item.conteudo"> </v-col>
                </v-row>
                <v-row v-if="item && item.observacao">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Observação:</div>
                  </v-col>
                  <v-col cols="12" sm="10" v-html="item.observacao"> </v-col>
                </v-row>
                <v-row v-if="item && item.palavrasChave && item.palavrasChave.length">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Palavras-chave:</div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    <span v-for="pc in item.palavrasChave" :key="pc.id">
                      {{ pc.palavrachave }};
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="mb-5" v-for="sb in item && item.suporteBase" :key="sb.id">
              <v-card-text class="py-5 px-10">
                <div>
                  <v-row
                    v-if="
                      sb.suporteBaseIdTipoSuporteFkrel && sb.suporteBaseIdTipoSuporteFkrel.descricao
                    "
                  >
                    <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ?
                    'text-right' : ''">
                      <div class="primary--text font-weight-medium">Tipo de suporte:</div>
                    </v-col>
                    <v-col cols="12" sm="10">
                      {{ sb.suporteBaseIdTipoSuporteFkrel.descricao }}
                    </v-col>
                  </v-row>
                  <v-row v-if="sb.suporteBaseEstadoFkrel && sb.suporteBaseEstadoFkrel.descricao">
                    <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ?
                    'text-right' : ''">
                      <div class="primary--text font-weight-medium">Conservação:</div>
                    </v-col>
                    <v-col cols="12" sm="10">
                      {{ sb.suporteBaseEstadoFkrel.descricao }}
                    </v-col>
                  </v-row>
                  <v-row v-if="sb.quantidade">
                    <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ?
                    'text-right' : ''">
                      <div class="primary--text font-weight-medium">Quantidade:</div>
                    </v-col>
                    <v-col cols="12" sm="10">
                      {{ sb.quantidade }}
                    </v-col>
                  </v-row>
                  <v-row v-if="sb.localizacaoFisica">
                    <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ?
                    'text-right' : ''">
                      <div class="primary--text font-weight-medium">Localização física:</div>
                    </v-col>
                    <v-col cols="12" sm="10">
                      {{ sb.localizacaoFisica }}
                    </v-col>
                  </v-row>
                  <v-row v-if="sb.extensao">
                    <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ?
                    'text-right' : ''">
                      <div class="primary--text font-weight-medium">Extensão:</div>
                    </v-col>
                    <v-col cols="12" sm="10">
                      {{ sb.extensao }}
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
            <v-card v-if="item && item.linkExterno">
              <v-card-text class="py-5 px-10">
                <form-title title="Links externos" class="mx-10" />
                <v-row v-for="linkExterno in item.linkExterno.split(';')" :key="linkExterno">
                  <v-col cols="12" sm="2" :class="$vuetify.breakpoint.smAndUp ? 'text-right' : ''">
                    <div class="primary--text font-weight-medium">Link:</div>
                  </v-col>
                  <v-col cols="12" sm="10">
                    <a :href="linkExterno" target="_blank">{{ linkExterno }}</a>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { baseURL, awsURL } from '@/services/container';
import viewTitle from '@/components/view-title.vue';
import formTitle from '@/components/form-title.vue';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import anexoImage from '@/components/collection-anexo-image.vue';
import dateFormatter from '@/mixins/date-formatter';

export default {
  mixins: [dateFormatter],
  components: {
    viewTitle,
    formTitle,
    anexoImage,
  },
  data() {
    return {
      baseURL,
      awsURL,
      dialog: false,
      motive: '',
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.afterRouteUpdate(to);
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.afterRouteUpdate(to);
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.clean();
    next();
  },
  computed: mapGetters('views/collection/read', [
    'item',
    'loading',
    'documentos',
    'options',
    'totalDocumentos',
    'footerProps',
    'isAdmin',
    'rejectedDialog',
    'notification',
    'acervo',
    'globalSearch',
  ]),
  methods: mapActions('views/collection/read', [
    'afterRouteUpdate',
    'clean',
    'loadDocumentos',
    'onApprove',
    'onReject',
    'onRejectedDialogInput',
  ]),
};
</script>
<style scoped>
.ck-editor__editable {
  min-height: 500px;
}
</style>
